<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import FormMatrixQuestionResults from '@/components/ConsultationSummary/QuestionResults/FormMatrixQuestionResults.vue';
import FormMultiChoiceQuestionResults from '@/components/ConsultationSummary/QuestionResults/FormMultiChoiceQuestionResults.vue';
import FormOpenQuestionResults from '@/components/ConsultationSummary/QuestionResults/FormOpenQuestionResults.vue';
import FormProposalQuestionResults from '@/components/ConsultationSummary/QuestionResults/FormProposalQuestionResults.vue';
import FormDotVotingQuestionResults from '@/components/ConsultationSummary/QuestionResults/FormDotVotingQuestionResults.vue';

import { Constants } from '@/constants';
import type { Locales } from '@/services/types/api.types';
import { useSummariesStore } from '@/stores/summaries.store';

// PROPS
const props = defineProps<{
  languageEnabled: Locales[];
  formId: number;
}>();

// STORE
const summariesStore = useSummariesStore();
const { formStats } = storeToRefs(summariesStore);

// CONST
const { t } = useI18n();
</script>
<template>
  <div class="form-summary-results">
    <div v-if="formStats.get(props.formId)?.type === Constants.Form.Type.Question">
      <div class="form-summary-results__title">
        {{ t('form.summary.results.graphic') }}
      </div>
      <FormMultiChoiceQuestionResults :form-id="props.formId" :language-enabled="props.languageEnabled" />
    </div>
    <div v-if="formStats.get(props.formId)?.type === Constants.Form.Type.Proposal">
      <div class="form-summary-results__title">
        {{ t('form.summary.results.graphic') }}
      </div>
      <FormProposalQuestionResults :form-id="props.formId" :language-enabled="props.languageEnabled" />
    </div>
    <div v-if="formStats.get(props.formId)?.type === Constants.Form.Type.Map">
      <div class="form-summary-results__map-question">
        {{ t('form.summary.status.map-question') }}
      </div>
    </div>
    <div v-if="formStats.get(props.formId)?.type === Constants.Form.Type.Matrix">
      <div class="form-summary-results__title">
        {{ t('form.summary.results.graphic') }}
      </div>
      <FormMatrixQuestionResults :form-id="props.formId" :language-enabled="props.languageEnabled" />
    </div>
    <div v-if="formStats.get(props.formId)?.type === Constants.Form.Type.OpenQuestion">
      <FormOpenQuestionResults :form-id="props.formId" :language-enabled="props.languageEnabled" />
    </div>
    <div v-if="formStats.get(props.formId)?.type === Constants.Form.Type.DotVoting">
      <FormDotVotingQuestionResults :form-id="props.formId" :language-enabled="props.languageEnabled">
        <template #title="{ title }">
          <div class="form-summary-results__title">
            {{ title }}
          </div>
        </template>
      </FormDotVotingQuestionResults>
    </div>
  </div>
</template>
<style lang="scss">
.form-summary-results {
  color: $color-neutral-black-text;
  padding: 0 $space-md;
  margin-bottom: $space-md;

  &__title {
    font-weight: bold;
    font-size: $sub-header;
    margin-bottom: 20px;
    padding: 0 !important;
    color: $color-neutral-black;
  }

  &__map-question {
    color: $color-neutral-grey-400;
    font-size: $small-text;
  }
}
</style>
